import Icon from '@components/v2/ui/Icon/Icon';
import ListItemButton from '@components/v2/ui/List/ListItemButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { ClarityEvents } from '../../../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../../../lib/clarity/utils/captureEvent.utils';
import { ColumnsVisibilityTestIds } from '../../../../../../utils/testIds/columnsVisibility.testIds';
import { ColumnVisibilityItem } from '../../columnsVisibility.types';

interface ColumnRowProps {
  column: ColumnVisibilityItem;
  onToggle: (key: string) => void;
}

const ColumnRow = ({ column, onToggle }: ColumnRowProps) => {
  const isDisabled = column.canHide === false;

  const iconColor = isDisabled
    ? 'text.disabled'
    : column.isVisible
      ? 'text.primary'
      : 'text.tertiary';

  return (
    <ListItemButton
      disabled={isDisabled}
      sx={{ '&.Mui-disabled': { opacity: 0.6 } }}
      testId={`${ColumnsVisibilityTestIds.COLUMN_ITEM_PREFIX}${column.key}`}
      onClick={withEvent(
        `${ClarityEvents.TOGGLE_COLUMN_VISIBILITY_WITH_NAME} ${column.name} to ${
          column.isVisible ? 'hidden' : 'visible'
        }`,
        () => onToggle(column.key),
      )}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography
          color={column.isVisible ? 'textPrimary' : 'textSecondary'}
          sx={{ textTransform: 'lowercase' }}
        >
          {column.name}
        </Typography>
        <Box component="span" sx={{ display: 'inline-flex', color: iconColor }}>
          <Icon icon={column.isVisible ? Eye : EyeOff} size="md" />
        </Box>
      </Box>
    </ListItemButton>
  );
};

export default ColumnRow;
